import {
  Globe2,
  ShieldCheck,
  Zap,
  MapPin,
  CreditCard,
  Wallet,
  Network,
  Lock,
  ServerCog,
  TrendingUp,
  Clock,
  Banknote,
  ShoppingBag,
  Landmark,
  Smartphone,
  Store,
  Receipt,
  Boxes,
  Eye,
} from "lucide-react";

const MAP = {
  Globe2,
  ShieldCheck,
  Zap,
  MapPin,
  CreditCard,
  Wallet,
  Network,
  Lock,
  ServerCog,
  TrendingUp,
  Clock,
  Banknote,
  ShoppingBag,
  Landmark,
  Smartphone,
  Store,
  Receipt,
  Boxes,
  Eye,
};

export const DynIcon = ({ name, className = "" }) => {
  const Cmp = MAP[name] || Globe2;
  return <Cmp className={className} aria-hidden="true" />;
};
